<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.PracticeManager"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [hasBackButton]="false"
></lib-site-setup-navbar>
<div class="flex max-w-[800px] flex-col items-center">
  <h1 class="typo-h1 mt-10 whitespace-pre-wrap text-center font-semibold">{{ 'site_install_practice_management_title' | translate }}</h1>
  <div class="mt-22 flex items-center">
    <div>
      <h4 class="typo-h4-semibold mb-8">{{ 'site_install_practice_management_subtitle' | translate }}</h4>
      <span class="typo-h4-light">{{ 'site_install_practice_management_description' | translate }}</span>
      <button
        class="btn-primary-big mt-8"
        [routerLink]="'/' + routes.siteAdminPracticeUserManagement(vm().contract?.data?.siteId ?? '')"
        [queryParams]="{
          fromInstaller: true
        }"
      >
        {{ 'site_install_practice_management_button' | translate }}
      </button>
    </div>

    <img src="/assets/images/practice-manager-illustration.png" class="-mr-20 w-[465px]" />
  </div>
</div>
